import React, { useEffect, useState } from 'react';
import arrowLeft from '../assets/arrow-left.png';
import arrowRight from '../assets/arrow-right.png';
import close from '../assets/close.png';

const Onset = () => {
  const [images, setImages] = useState([]);

  // Lightbox state
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Fetch images
  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/onset`);
      if (response.ok) {
        const data = await response.json();
        setImages(
          data.map((image) => ({
            src: image.image,
            alt: image.alt,
            caption: image.caption || '',
          }))
        );
      } else {
        console.error('Error fetching images');
      }
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  };

  // Lightbox functions
  const openLightbox = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <>
      {/* <div className="bg-[#252525] w-full min-h-screen"> */}
        <div className="bg-[#252525] min-h-screen py-8 xl:px-[150px] lg:px-[150px] px-[30px]">
        {/* Single column: one large image per row, caption directly underneath. */}
        <div className="mx-auto max-w-[1100px] px-4 py-10 md:py-14">
          {images.map((image, index) => (
            <figure key={index} className="m-0 mb-14 last:mb-0">
              <div
                className="w-full cursor-pointer transition-opacity duration-300 hover:opacity-90"
                onClick={() => openLightbox(index)}
              >
                <img
                  src={image.src}
                  alt={image.alt || image.caption || 'On set'}
                  className="block w-full h-auto"
                />
              </div>

              {image.caption ? (
                <figcaption className="font-dropdown mt-4 text-[15px] leading-relaxed text-[#b7a78b]">
                  {image.caption}
                </figcaption>
              ) : null}
            </figure>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {isOpen && images.length > 0 && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="relative flex items-center justify-center w-full">
            {/* Previous Button */}
            <button
              onClick={goToPrev}
              className="absolute left-4 text-white text-3xl w-10 h-10 flex items-center justify-center"
            >
              <img width="24" height="24" src={arrowLeft} alt="Previous" />
            </button>

            {/* Image + caption */}
            <div className="relative inline-block max-h-screen">
              <img
                src={images[currentIndex].src}
                alt={`Lightbox ${currentIndex + 1}`}
                className="block max-w-full max-h-screen"
              />
              {images[currentIndex].caption ? (
                <div className="font-dropdown absolute bottom-0 left-0 right-0 bg-black/70 px-5 py-4 text-[#e4e4e3] text-[15px] leading-relaxed">
                  {images[currentIndex].caption}
                </div>
              ) : null}
            </div>

            {/* Next Button */}
            <button
              onClick={goToNext}
              className="absolute right-4 text-white text-3xl w-10 h-10 flex items-center justify-center"
            >
              <img width="24" height="24" src={arrowRight} alt="Next" />
            </button>

            {/* Close Button */}
            <button
              onClick={closeLightbox}
              className="absolute top-4 right-4 text-white text-3xl w-10 h-10 flex items-center justify-center"
            >
              <img width="24" height="24" src={close} alt="Close" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Onset;
